import { useMutation, useQueryClient } from "@tanstack/react-query";

import { User } from "../../../../types/types";

import { unfollowEntityService } from "../../../Entity/api/services/follow";
import { entityKeys } from "../../../Entity/api/queryKeys";

import { unfollowUserService } from "../services/follow";

import { userKeys } from "../queryKeys";

interface UseUnfollowMutationProps {
  onSuccess?: (isFollowing: boolean) => void;
  onError?: (error: Error) => void;
}

export const useUnfollowMutation = ({ onSuccess, onError }: UseUnfollowMutationProps = {}) => {
  const queryClient = useQueryClient();

  const unfollowUser = useMutation({
    mutationFn: unfollowUserService,
    onSuccess: (isFollowing, userId) => {
      queryClient.invalidateQueries({ queryKey: ["NetworkList"] });
      queryClient.invalidateQueries({ queryKey: ["UserProfile"] });
      queryClient.invalidateQueries({ queryKey: [...userKeys.profile(String(userId))] });

      onSuccess?.(isFollowing);
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });

  const unfollowEntity = useMutation({
    mutationFn: (entityId: number) => unfollowEntityService(entityId),
    onSuccess: (isFollowing, entityId) => {
      queryClient.invalidateQueries({ queryKey: ["NetworkList"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile"] });
      queryClient.invalidateQueries({ queryKey: entityKeys.details(String(entityId)) });

      onSuccess?.(isFollowing);
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });

  const unfollow = (user: User) => {
    if (user.entity?.id) {
      unfollowEntity.mutate(user.entity.id);
    } else if (user.id) {
      unfollowUser.mutate(user.id);
    }
  };

  return {
    unfollow,
    isLoading: unfollowUser.isPending || unfollowEntity.isPending,
    error: unfollowUser.error || unfollowEntity.error,
  };
};
